import React from "react";
import { func, shape, string } from "prop-types";

import "./menu-item.m.css";

const MenuItem = ({ item, onClick }) => (
  <span onClick={() => onClick(item.id)} styleName="wrapper">
    {item.menu}
  </span>
);

MenuItem.propTypes = {
  item: shape({
    id: string,
    menu: string
  }),
  onClick: func
};

export default MenuItem;
